export async function executeWithRetries<T extends unknown[], R>(
  fn: (...args: T) => Promise<R> | R,
  args: T,
  maxRetries = 3,
  delayMs = 1000,
): Promise<R> {
  let attempts = 0;
  while (attempts < maxRetries) {
    try {
      return await fn(...args);
    } catch (error) {
      attempts++;
      if (attempts === maxRetries) {
        throw error;
      }
      await new Promise((resolve) => setTimeout(resolve, delayMs));
    }
  }
  throw new Error('Max retries reached');
}
